<template>
  <v-layout>
    <v-row>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.code"
            label="Kod"
            counter="8"
            :rules="rules.code"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.nip"
            label="Numer NIP"
            counter="10"
            :rules="rules.nip"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-select
            class="mt-0 pt-0"
            v-model="standardFilters.status"
            label="Status"
            :items="statuses"
            item-value="value"
            item-text="text"
            hide-details
        ></v-select>
      </v-col>
      <v-col cols="12">

      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { getItems as getCodeStatusItems } from '@/enums/CodeStatus';
import {setDatatableFilters} from "@/utils/helpers";
import debounce from "debounce";

export default {
  data() {
    return {
      filterCodesDebouncing: null,
      standardFilters: {
        status: '',
      },
      debouncedFilters: {
        code: '',
        nip: '',
      },
      statuses: [
        {value: '', text: 'Dowolny'},
        // "G" is not supported by API in this case.
        ...getCodeStatusItems(false),
      ],
      rules: {
        code: [
          (value) => {
            if (!value) {
              return true;
            }

            return (value.length >= 2 && value.length <= 8) || 'Wartość musi mieć długość 2 - 8 znaków.';
          },
        ],
        nip: [
          (value) => {
            if (!value) {
              return true;
            }

            return (value.length >= 3 && value.length <= 10) || 'Wartość musi mieć długość 3 - 10 znaków.';
          },
        ],
      },
    };
  },
  created() {
    this.filterCodesDebouncing = debounce(function () {
      this.filterCodes();
    }, 500);
  },
  watch: {
    standardFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterCodes();
      },
      deep: true
    },
    debouncedFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterCodesDebouncing();
      },
      deep: true
    },
  },
  methods: {
    filterCodes() {
      this.$root.$emit('loadCodes', {
        filters: {
          ...this.standardFilters,
          ...this.debouncedFilters,
        },
        onSuccess: () => {
          this.$root.$emit('notify', {
            html: 'Filtrowanie zakończone.',
          });
        }
      });
    },
  }
}
</script>